import React from 'react';

import { faGrip } from '@fortawesome/free-solid-svg-icons/faGrip';
import { faStop } from '@fortawesome/free-solid-svg-icons/faStop';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ActionIcon, Flex, Slider, Text } from '@mantine/core';

interface ClonotypeSizeSliderProps {
  count: number;
  setCount: (count: number) => void;
  values: number[];
}

export function ClonotypeSizeSlider({ count, setCount, values }: ClonotypeSizeSliderProps) {
  const marks = React.useMemo(() => {
    return values.map((value) => ({ value, label: value.toString() }));
  }, [values]);

  // Live value while the user is dragging — kept local so the inline label
  // updates immediately without triggering parent re-renders on every step.
  const [liveValue, setLiveValue] = React.useState(count);
  React.useEffect(() => {
    setLiveValue(count);
  }, [count]);

  const handleMin = React.useCallback(() => {
    setCount(Math.min(...values));
  }, [setCount, values]);

  const handleMax = React.useCallback(() => {
    setCount(Math.max(...values));
  }, [setCount, values]);
  return (
    <Flex gap={8} align="center" wrap="nowrap" className="shrink-0">
      <Text size="sm" fw={500} style={{ whiteSpace: 'nowrap' }}>
        Grid size:{' '}
        <Text component="span" size="sm" fw={600} c="#0064B0">
          {liveValue}
        </Text>
      </Text>
      <Flex gap={4} align="center">
        <ActionIcon variant="subtle" c="gray.5" size="xs" onClick={handleMin}>
          <FontAwesomeIcon icon={faStop} />
        </ActionIcon>

        <Slider
          data-testid="clonotype-size-slider"
          key={count}
          size="sm"
          w={150}
          defaultValue={count}
          step={1}
          min={1}
          max={marks.length}
          marks={marks}
          label={null}
          onChange={setLiveValue}
          onChangeEnd={(value) => setCount(value)}
          styles={{ markLabel: { display: 'none' } }}
        />
        <ActionIcon variant="subtle" c="gray.5" size="xs" onClick={handleMax}>
          <FontAwesomeIcon icon={faGrip} color="gray" />
        </ActionIcon>
      </Flex>
    </Flex>
  );
}
